import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackBASMonitoring} from '@aboutyou/tracking';
import React from 'react';
import styled from 'styled-components';
import {Advertisement} from '../../../features/Advertisement/Advertisement';

export interface BASPlacementProps {
  className?: string;
}

export const BASPlacementView: React.FC<
  GetProductBulkResponse['basPlacementSection'] & BASPlacementProps
> = ({basPlacement, className}) => {
  if (!basPlacement)
    return (
      <TrackBASMonitoring
        basPromotionSource={TrackingPromotionCreative.BasAdpBanner}
      />
    );

  return (
    <StyledAdvertisement
      className={className}
      advertisement={basPlacement}
      testId="advertisementBuyingBox"
      tracking={{
        promotionSource: TrackingPromotionCreative.BasAdpBanner,
      }}
    />
  );
};

const StyledAdvertisement = styled(Advertisement)`
  margin-bottom: 30px;
`;
